import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { CFIEstimateDetails } from '../types/CFIEstimateDetails';

export const useGetEstimate = (quoteID: number) => {
    const { data, isLoading, refetch, isRefetching } = useQuery({
        queryKey: ['cfi-estimate', quoteID],
        queryFn: async () => await apiClient.get('estimate/cfi-details',
            {
                params: {
                    quoteID: quoteID
                }
            }) as CFIEstimateDetails
    });

    return {
        data,
        isLoading,
        refetch,
        isRefetching
    };
};
